import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasReportecomisionesListaComponent (FinanzasReportecomisiones) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.exportar = exportar

  function $onInit () {
    $ctrl.$promise = FinanzasReportecomisiones.get(
      $ctrl.busqueda.fechaInicial,
      $ctrl.busqueda.fechaFinal,
      $ctrl.busqueda.comisionistas,
      $ctrl.busqueda.proveedores,
      $ctrl.busqueda.clientes,
    ).then(function (response) {
      $ctrl.data = response.data
    })
  }

  function exportar () {
    FinanzasReportecomisiones.exportarXLS($ctrl.data)
  }
}

module.component('finanzasReportecomisionesLista', {
  controller: FinanzasReportecomisionesListaComponent,
  template,
  bindings: {
    busqueda: '<',
    form: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/reportecomisiones/components/lista/component.js